import React from 'react'
import { CtaDescriptionPosition, CtaDescriptionWidth } from '../lib/types'

interface CtaButtonContextValue {
  descriptionPosition: CtaDescriptionPosition
  descriptionWidth: CtaDescriptionWidth
  showCtaDescription: boolean
}

export const DefaultCtaButtonContext: CtaButtonContextValue = {
  descriptionPosition: CtaDescriptionPosition.Center,
  descriptionWidth: CtaDescriptionWidth.Auto,
  showCtaDescription: true,
}

const CtaButtonContext = React.createContext<CtaButtonContextValue>(DefaultCtaButtonContext)

export const CtaButtonMetadataProvider = CtaButtonContext.Provider
export const useCtaButtonMetadata = () => React.useContext(CtaButtonContext)
